import React, { useState, useEffect, useRef } from "react";
import { useNotifications } from "../../context/NotificationContext";
import NotificationDropdown from "./NotificationDropdown";
import { playNotificationSound } from "../../utils/notificationSound";
import { IoNotificationsOutline } from "react-icons/io5";

const NotificationBell = () => {
  const { unreadCount } = useNotifications();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleOpen = () => {
    playNotificationSound();
    setOpen((s) => !s);
  };

  // ✅ Click outside listener to close dropdown when clicking anywhere on screen
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={toggleOpen}
        className="relative h-9 w-9 flex items-center justify-center rounded-full bg-transparent shadow-lg shadow-black/5 hover:bg-white/10 transition-all border border-white/50 hover:border-white"
        aria-label="Notifications"
      >
        <IoNotificationsOutline className="text-xl text-white" />

        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-extrabold w-5 h-5 flex items-center justify-center rounded-full shadow-md animate-pulse">
            {unreadCount}
          </span>
        )}
      </button>

      {open && (
        <div className="fixed inset-x-0 mx-4 top-16 sm:absolute sm:inset-auto sm:right-0 sm:mt-3 z-50">
          <NotificationDropdown onClose={() => setOpen(false)} />
        </div>
      )}
    </div>
  );
};

export default NotificationBell;